import { cn } from '@/lib/cn';
import { type JSX, Show, createSignal } from 'solid-js';

/** <img> with a pulse + spinner placeholder until the (signed-URL) image loads. */
export const DeviceImage = (props: { src: string; alt: string; class?: string }): JSX.Element => {
  const [loaded, setLoaded] = createSignal(false);
  return (
    <span class={cn('relative block overflow-hidden', props.class)}>
      <img
        src={props.src}
        alt={props.alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        class={cn(
          'h-full w-full object-cover transition-opacity duration-300',
          !loaded() && 'opacity-0',
        )}
      />
      <Show when={!loaded()}>
        <span class="absolute inset-0 flex animate-pulse items-center justify-center bg-neutral-100 dark:bg-neutral-800">
          <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-neutral-400 border-t-transparent" />
        </span>
      </Show>
    </span>
  );
};
